exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.custom_grid[data-v-47b0a1ec] {\n  display: -ms-grid;\n  display: grid;\n  -ms-grid-columns: auto 1fr;\n      grid-template-columns: auto 1fr;\n  -ms-grid-rows: 1fr;\n      grid-template-rows: 1fr;\n  grid-column-gap: 0px;\n  grid-row-gap: 0px;\n  -ms-flex-align: center;\n      align-items: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-47b0a1ec","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Resume/Summary/AgentSelector.vue
// module id = 2835
// module chunks = 0